import { MapPinProps } from '.';

const mapPinColorGenerator = (backgroundColor : string ,foregroundColor : string) => {

  const generatedStyle : MapPinProps =  {
    pinBackgroundColor: backgroundColor,
    bottomDotBackgroundColor: foregroundColor,
    bottomDotStrokeColor: backgroundColor,
  }

  return generatedStyle
}


export  { mapPinColorGenerator }



